import React from 'react';
import { Link } from '@cdl/heartbeat-react';
import reactStringReplace from 'react-string-replace';

export const highlightLinks = (text: string): Iterable<React.ReactNode> => {
  const urlRegexp =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;

  return reactStringReplace(text, urlRegexp, (match, i) => (
    <Link
      key={i}
      href={match}
      target='_blank'
      textDecoration='none'
      color='primary.500'
      sx={{
        _hover: {
          textDecoration: 'none',
        },
      }}
    >
      {match}
    </Link>
  ));
};
